const FAQ = function () {
  jQuery(document).ready(function ($) {
    if (jQuery('.faq-list').length > 0) {
      jQuery(document).on('click', '.qa-item .faq-question h3', function () {
        jQuery(this).parents('.qa-item').toggleClass('active');

        jQuery(this).parents('.qa-item').find('.faq-answer').toggle('400');
      })
    }
  });

};

module.exports = FAQ;